import { render, staticRenderFns } from "./CoinsByLocationSnippet.vue?vue&type=template&id=4fa2dade&"
import script from "./CoinsByLocationSnippet.vue?vue&type=script&lang=js&"
export * from "./CoinsByLocationSnippet.vue?vue&type=script&lang=js&"
import style0 from "./CoinsByLocationSnippet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports